import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import {
  LoginForm,
  RegisterForm,
  ForgotPasswordForm,
  ResetPasswordForm,
} from "../dashboard/auth";
import { Home } from "../dashboard/home";
import { UsersManagement } from "../dashboard/users";
import { ModalAnswer } from "../dashboard/modal-answer";
import { PastModalAnswer } from "../dashboard/past-modal-answer";
import { Submissions, ResultDetails } from "../dashboard/submissions";
import { FlaggedEssays } from "../dashboard/flagged";
import { Profile } from "../dashboard/profile";
import { Layout } from "../component/layout";
import AuthRoute from "./AuthRoute";
import { PaymentHistory, ComingSoon, PlansManagement } from "../dashboard/payment";

const AppRoutes = () => {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <AuthRoute type="public">
            <LoginForm />
          </AuthRoute>
        }
      />
      <Route
        path="/register"
        element={
          <AuthRoute type="public">
            <RegisterForm />
          </AuthRoute>
        }
      />
      <Route
        path="/forgot-password"
        element={
          <AuthRoute type="public">
            <ForgotPasswordForm />
          </AuthRoute>
        }
      />
      <Route
        path="/reset-password"
        element={
          <AuthRoute type="public">
            <ResetPasswordForm />
          </AuthRoute>
        }
      />

      <Route
        element={
          <AuthRoute type="protected">
            <Layout />
          </AuthRoute>
        }
      >
        <Route path="/dashboard" element={<Home />} />
        <Route path="/users" element={<UsersManagement />} />
        <Route path="/modal-answer" element={<ModalAnswer />} />
        <Route path="/past-modal-answer" element={<PastModalAnswer />} />
        <Route path="/submissions" element={<Submissions />} />
        <Route path="/submissions/:id" element={<ResultDetails />} />
        <Route path="/flagged" element={<FlaggedEssays />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/payment-history" element={<PaymentHistory />} />
        <Route path="/payments" element={<ComingSoon />} />
        <Route path="/plans" element={<PlansManagement />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />

    </Routes>
  );
};

export default AppRoutes;
